
export const START_DATE_STR = "2010-01-01";